module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wSiD6B/tc-custom/9781504094573.jpg?1718282807506",
      "alt": "This image is the cover for the book February or Forever, Tarrin’s Bay"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("February or Forever, Tarrin’s Bay\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What if you were hired to work with your favourite celebrity?"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Yoga teacher and single mother, Chrissie Burns has a plan: move into the rundown beach house she’s inherited; the scene of a terrible accident years ago, renovate it, sell it, and move on."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But the town offers more than bad memories. The people are friendly, and even Chrissie's young son finds friends and begins coming out of his shell."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Employed at a retreat as a yoga instructor, Chrissie is shocked to discover she will be teaching Drew Williams, Australia's top singer songwriter."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Relationships between instructors and clients are strictly forbidden, but their attraction is undeniable."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" And when it’s time for Drew to leave Tarrin’s Bay, can the romance last or is it doomed to fail?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Juliet Madison\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0